import React from "react";

const EnergyCircleIcon = ({
  size = 12,
  fillBg = "#FAD152",
  fillIcon = "#085054",
}) => {
  return (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 12 12"
      >
        <path fill={fillBg} d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10" />
        <path
          fill={fillIcon}
          d="M4.329 8.51h.68a.2.2 0 0 0 .2-.2V6.894a.2.2 0 0 1 .07-.152l.158-.135a.2.2 0 0 1 .296.041L6.914 8.42a.2.2 0 0 0 .166.09h.361a.2.2 0 0 0 .164-.316L6.16 6.144a.2.2 0 0 1 .022-.257l.052-.051a.2.2 0 0 1 .306.029l1.74 2.557a.2.2 0 0 0 .165.087h.315a.2.2 0 0 0 .166-.311L7.008 5.346a.2.2 0 0 1 .025-.253l1.249-1.248a.2.2 0 0 0-.142-.342h-.8a.2.2 0 0 0-.14.057L5.55 5.164a.2.2 0 0 1-.34-.143V3.703a.2.2 0 0 0-.2-.2h-.68a.2.2 0 0 0-.2.2V8.31c0 .11.09.2.2.2"
        />
      </svg>
    </span>
  );
};

export default EnergyCircleIcon;
